import {DataTablesSchema} from "@commons/mapping/DataTablesSchema";
import {PaginationReturnType, SearchParamsType} from "@components/dataTable/usePagination";
import {useCallback, useEffect, useMemo, useState} from "react";
import {normalizeStr} from "@components/dataTable/customHooks";
import useDeepCompareEffect from "use-deep-compare-effect";
import {useWhatChanged} from "@simbathesailor/use-what-changed";

type SearchFnType = (searchParams: any, element: any, index: number, array: any[]) => boolean;

export function useClientSideProcessing<T extends object, Key extends string & keyof T | undefined = undefined, SearchType = string>(dtSchema: DataTablesSchema<T> | undefined,
                                                                                                                                     pagination: Pick<PaginationReturnType<SearchType>, 'search' | 'getStart' | 'page' | 'pageLength' | 'setServerSide' | 'setHasSearch' | 'setPage'>,
                                                                                                                                     searchFilter: Key[] = [],
                                                                                                                                     searchFnFilter?: SearchFnType,
): DataTablesSchema<T> | undefined {
    const searchFn = useCallback((sp: SearchParamsType, props: Key[], element: T) => {
        let include = false;
        Object.keys(element)
            .filter(key => props.indexOf(key as Key) >= 0).forEach(key => {
            //console.log(element[key]);
            // @ts-ignore
            if (normalizeStr(element[key]).indexOf(normalizeStr(sp.value)) >= 0)
                include = true;
        })
        return include;
    }, []);

    const [memoSearchFilter, setNextMemoSearchFilter] = useState<Key[]>();

    useDeepCompareEffect(() => {
        setNextMemoSearchFilter(searchFilter);
    }, [searchFilter]);

    const searchValue = pagination.search;

    useEffect(() => {
        pagination.setServerSide(false);
        pagination.setHasSearch(searchFilter ? true : false);
    }, [pagination, searchFilter]);

    useEffect(() => {
        pagination.setPage(1);

    }, [dtSchema?.data]); // N.B. non includere pagination nelle dipendenze!

    //useWhatChanged([dtSchema, searchValue, memoSearchFilter, searchFnFilter, pagination, searchFn], 'dtSchema, searchValue, memoSearchFilter, searchFnFilter, pagination, searchFn');

    return useMemo<DataTablesSchema<T>>(() => {
        const typeset = (data: any[]) => {
            if (data) {
                const start = pagination.getStart();
                return data.slice(start, start + pagination.pageLength);
            } else
                return [];
        }

        if (dtSchema) {
            //console.log("Init useClientSideProcessing!")
            const searchParams = searchValue ? {value: searchValue, regex: false} : null;
            let newData: T[] = [];
            let recordsTotal: number;
            if (dtSchema) {
                //recordsTotal = dtSchema.recordsTotal;
                recordsTotal = dtSchema.recordsFiltered;
                if (searchParams && typeof searchParams.value === "string") {
                    if (searchParams.value && memoSearchFilter?.length) {
                        newData = dtSchema.data.filter((element) => searchFn(searchParams as SearchParamsType<string>, memoSearchFilter as Key[], element));
                    } else
                        newData = dtSchema.data;
                } else if (searchParams && searchParams.value && searchFnFilter) {
                    newData = dtSchema.data.filter((element, index, array) => searchFnFilter(searchParams.value, element, index, array));
                } else
                    newData = dtSchema.data;
            } else {
                recordsTotal = 0;
            }
            return {data: typeset(newData), recordsFiltered: newData.length, recordsTotal};
        } else
            return {data: [], recordsFiltered: 0, recordsTotal: 0};
    }, [dtSchema, searchValue, memoSearchFilter, searchFnFilter, pagination, searchFn]);
}
